export default () => (
  /**
   * Ícone para fechar imagem em modal de camada tipo 'jpg/jpeg'
   */
<svg
  width="11"
  height="11"
  viewBox="0 0 11 11"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <line
    x1="0.75"
    y1="-0.75"
    x2="11.7602"
    y2="-0.75"
    transform="matrix(-0.707107 0.707107 0.707107 0.707107 10.1133 2.14062)"
    stroke="#C3C3C9"
    strokeWidth="1.5"
    strokeLinecap="round"
  />
  <line
    x1="0.75"
    y1="-0.75"
    x2="11.7602"
    y2="-0.75"
    transform="matrix(0.707107 0.707107 0.707107 -0.707107 1.26562 0.976562)"
    stroke="#C3C3C9"
    strokeWidth="1.5"
    strokeLinecap="round"
  />
</svg>

  
);
